import React, { Component } from 'react'
import { connect } from 'react-redux'
import 'tui-calendar/dist/tui-calendar.css';

// If you use the default popups, use this.
import 'tui-date-picker/dist/tui-date-picker.css';
import 'tui-time-picker/dist/tui-time-picker.css';

import { getAllEvents, createEvent } from '../../actions/events-actions';
import { getAllUsers } from '../../actions/admin-actions';
import { getBadgeColor } from '../../actions/user-actions';
import { getTickers } from '../../actions/tickers-actions';

import calendarStyles from './styles/calendar.module.scss';
import { Row } from 'react-flexbox-grid';

import './styles/calendarStyles.scss';
import { interceptor } from '../../services/interceptor-service';
import "isomorphic-fetch";
import { ToastsContainer, ToastsStore } from 'react-toasts';
import SyncModal from './components/SyncModal';
import CreateEventModal from './components/CreateEventModal';
import TaskModal from './components/TaskModal'
import NoteModal from './components/NoteModal'
import ReminderModal from './components/ReminderModal';
import TUICalendar from './components/TUICalendar';
import moment from "moment";
import Tutorial from '../../components/Tutorial';

export class LiveliCalendar extends Component {

    calendarRef = React.createRef();
    user = JSON.parse(localStorage.getItem('user'));

    state = {
        showModal: false,
        showCreationModal: false,
        showTaskModal: false,
        showEditionModal: false,
        showConfirmDeleteEvent: false,
        showReminderModal: false,
        isEditingReminder: false,
        isEditingTask: false,
        isEditingNote: false,
        date: {
            month: 0,
            year: 0
        },
        creationEvent: {},
        task: {},
        note: {},
        reminder: {},
        refresh: false
    }


    componentDidMount() {
        var data = {
            email: this.user.email,
            sortKey: this.user.sortKey
        }
        this.props.getBadgeColor(data)
        this.props.getTickers(data)
        this.props.getAllUsers()
        this.props.getAllEvents(moment(this.props.defaultDate).format('YYYY-MM'));
        localStorage.setItem('flagReload', 'false')
    }

    componentDidUpdate(prevProps) {                  
        if (!this.props.loading && !prevProps.eventsError && this.props.eventsError) {            
            interceptor.removeTokens();
            window.location.href = '/';
        }
    }

    closeCreationModal = () => {
        this.setState({ showCreationModal: false });
    }

    closeEditionModal = () => {
        if(this.props.showEditionModal){
            this.props.displayModal(false)
        }
        else{
            this.setState({showEditionModal: false});
        }
    }

    closeEventDeletionModal = () => {
        this.setState({ showConfirmDeleteEvent: false })
    }

    handleEditEvent = (event) => {
        this.setState({
            showEditionModal: true,
            editionEvent: event
        })
    }

    handleBeforeCreateSchedule = (ev) => {
        if (ev.guide)
            ev.guide.clearGuideElement();
        this.setState({
            showCreationModal: true,
            creationEvent: ev
        }, 
        );
        
    }

    showScheduleModal = (ev, scheduleType, showModalFlag, editFlag, isEditing) => {
        this.setState({
            [scheduleType]: {
                ...ev
            },
            [showModalFlag]: true,
            [editFlag]: isEditing
        })
    }

    handleOpenModal = () => {
        this.setState({ showModal: true });
    }

    handleCloseModal = () => {
        this.setState({ showModal: false });
    }

    handleCloseTaskModal = () => {
        this.setState({ showTaskModal: false });
    }

    handleCloseNoteModal = () => {
        this.setState({ showNoteModal: false });
    }

    handleCloseReminderModal = () => {
        if(this.props.showReminderModal){
            this.props.displayModal(false)
        }
        else{
            this.setState({ showReminderModal: false });
        }
    }



    goSettings = () => {
        window.location.href = "/main/settings";
        localStorage.setItem('menu', "settings")
    }

    render() {
        return (
            <Row className={[calendarStyles.__container].join(' ')}>
                <Tutorial stepsEnabled={true} type={'calendar'}/>
                <ToastsContainer store={ToastsStore} />
                {this.state.showModal &&
                    <SyncModal
                        title="Calendar Synchronization"
                        go={this.goSettings}
                        onClose={this.handleCloseModal}
                    />
                }
                {this.state.showTaskModal &&
                    <TaskModal
                        onClose={this.handleCloseTaskModal}
                        task={this.state.task}
                        isEditing={this.state.isEditingTask}
                    />
                }
                { this.state.showNoteModal &&
                    <NoteModal
                        onClose={this.handleCloseNoteModal}
                        note={this.state.note}
                        isEditing={this.state.isEditingNote}
                    />
                }
                {this.state.showCreationModal &&
                    <CreateEventModal
                        title="Create Event"
                        creationEvent={this.state.creationEvent}
                        isEditing={false}
                        onClose={this.closeCreationModal}
                        colorData={this.props.colorData.badgeColor}
                    />
                }
                {(this.props.showEditionModal !== this.state.showEditionModal) && (this.props.showEditionModal || this.state.showEditionModal)  &&
                    <CreateEventModal
                        title='Edit Event'
                        creationEvent={this.props.showEditionModal ? this.props.editionEvent : this.state.editionEvent}
                        isEditing={true}
                        onClose={this.closeEditionModal}
                        colorData={this.props.colorData.badgeColor}
                    />
                }
                {(this.props.showReminderModal !== this.state.showReminderModal) && (this.props.showReminderModal || this.state.showReminderModal)  &&
                    <ReminderModal
                        title={`${this.props.showReminderModal  || this.state.isEditingReminder ? 'Edit Reminder' : 'Create Reminder'}`}
                        originReminder={this.props.showReminderModal ? this.props.editionEvent: this.state.reminder}
                        isEditing={this.props.showReminderModal ? true: this.state.isEditingReminder}
                        onClose={this.handleCloseReminderModal}
                    />
                }
                <TUICalendar
                    handleOnClickSchedule={this.handleOnClickSchedule}
                    handleCreateEvent={this.handleBeforeCreateSchedule}
                    showScheduleModal={this.showScheduleModal}
                    handleEditEvent={this.handleEditEvent}
                    handleOpenModal={this.handleOpenModal}
                />
            </Row>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        userProfile: state.userReducer.userProfile,
        events: state.eventsReducer.events,
        recurrentEvents: state.eventsReducer.recurrentEvents,
        eventsToShow: state.eventsReducer.eventsToShow,
        errorType: state.eventsReducer.errorStatus,
        eventsError: state.eventsReducer.eventsError,
        errorMessage: state.eventsReducer.errorMessage,
        loading: state.eventsReducer.loading,
        allForecastsFetched: state.eventsReducer.allForecastsFetched,
        getTickresSuccess: state.tickersReducer.getTickresSuccess,
        tickersData: state.tickersReducer.tickersData,
        getBadgeSuccess: state.userReducer.getBadgeSuccess,
        colorData: state.userReducer.colorData,
        defaultDate: state.userReducer.defaultDate,
        stepTutorial: state.userReducer.stepTutorial
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getAllEvents: (sort) => dispatch(getAllEvents(sort)),
        getAllUsers: () => dispatch(getAllUsers()),
        getBadgeColor: (userData) => dispatch(getBadgeColor(userData)),
        getTickers: (userData) => dispatch(getTickers(userData)),
        putTasks: (data) => dispatch(createEvent(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LiveliCalendar)


